import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import React from 'react';

const apiKey = process.env.NEXT_PUBLIC_BUGSNAG_API_KEY;

Bugsnag.start({
    apiKey,
    plugins: [new BugsnagPluginReact()],
});

const ErrorBoundary = Bugsnag.getPlugin('react')?.createErrorBoundary(React);

export { ErrorBoundary };
